export interface IPricingPlan {
  title: string;
  price: string;
  period: string;
  guarantee: string;
  features: string[];
  cta: string;
}

export const pricingPlan: IPricingPlan = {
  title: 'Slechts',
  price: '€39',
  period: 'Per Maand',
  guarantee: 'De beste prijs is de juiste prijs',
  features: [
    '<b>Maak kosteloos</b>: </br> In één click een nieuw account aan voor een ander filiaal',
    '<b>Geschikt voor:</b> </br> Zowel kleine als grote dienstencheque bedrijven',
    'Strijk inboeken met behulp van een handscanner',
    'Borderellen in één handomdraai',
    'Complete Loonadministratie',
    'Documenten en Rapporten'
  ],
  cta: 'Meer ...'
};
